import React, { useEffect, useState } from 'react';
import { FeatureGroup, MapContainer, Marker, Popup, TileLayer, useMapEvents } from 'react-leaflet';
import L, { latLngBounds } from 'leaflet';
import MarkerIcon from '../assets/MarkerIcon.png';
import MyLocationMarkerIcon from '../assets/MyLocationMarkerIcon.png';

function LeafletMapComponent(props) {
    const [map, setMap] = useState(null);

    useEffect(() => {
        if (map) {
            let markerBounds = latLngBounds([]);
            if (position) {
                markerBounds.extend(position)
            }
            if (merchantMarkers.length && merchantMarkers.length > 0) {
                merchantMarkers.forEach(m => {
                    markerBounds.extend([m.lat, m.lng])
                })
                map.fitBounds(markerBounds)
            }
        }
    }, [map])

    const MyComponent = () => {
        const map = useMapEvents({
            load: e => {
            }
        });
        // const map = useMapEvents({
        //     // click: (e) => {
        //     //     const { lat, lng } = e.latlng;
        //     //     L.marker([lat, lng], { icon: markerIcon }).addTo(map);
        //     // },
        //     locationfound: (e) => {
        //         console.log('latlng', e)
        //         const { lat, lng } = e.latlng;
        //         //setPosition([lat, lng]);
        //         // L.marker([lat, lng], { icon: markerIcon }).addTo(map);
        //         // map.flyTo(e.latlng, 14);
        //     }
        // });
        return null;
    }

    const markerIcon = new L.icon({
        iconUrl: MarkerIcon,
        iconSize: [35, 40]
    });
    const myLocationMarkerIcon = new L.icon({
        iconUrl: MyLocationMarkerIcon,
        iconSize: [80, 80]
    });

    const position = props.position;
    const merchantMarkers = props.merchantMarkers;

    return (
        <MapContainer center={position} zoom={12} scrollWheelZoom={true} style={{ width: '90%', height: '60vh', margin: 'auto', marginTop: '10px' }} scrollWheelZoom={true}
            whenCreated={(m) => {
                setMap(m);
            }}>
            <TileLayer
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                attribution='<a style="color:black;" href="https://www.gazh.ir">ژرف &reg;</a>'
            />
            <MyComponent />
            <FeatureGroup>
                {position && <Marker position={position} icon={myLocationMarkerIcon}>
                    <Popup>
                        موقعیت مکانی شما
                    </Popup>
                </Marker>}
                {
                    merchantMarkers.map((item) => <Marker position={[item.lat, item.lng]} icon={markerIcon}>
                        <Popup>
                            <div style={{cursor:'pointer'}} onClick={()=>props.handleDialogOpen(item)}>
                                <b>{item.guildName}</b>
                                <br />
                                {item.name}
                            </div>
                        </Popup>
                    </Marker>)
                }
            </FeatureGroup>
        </MapContainer>
    );
}

export default LeafletMapComponent;